import {makeGet, makePost} from '../make';

export interface ILogin {
    Password: string
}

interface IAuth {
    // code:   number,
    expire: string,
    // token:  string,
}

export const apis = {
  login: makePost<ILogin, IAuth>('/auth/login'),
  refresh: makeGet<any, IAuth>('/auth/refresh'),
  logout: makePost<{}, null>('/auth/logout'),
};
